import React, { Component, } from 'react'

import {strings, CCCoinPile, CCUIUtils, CCUtils, colors} from "./../../cc-imports";
// import './transaction-item.css'
import './../../styles/css/components/CCTransactionItem/cc-transaction-item.css'


class TransactionItem extends Component {

    static propTypes = {}
    static defaultProps = { first: false }


    constructor(props) {
        super(props)
        this.state = {}
        this._getMessage = this._getMessage.bind(this);
        this._getTitle = this._getTitle.bind(this);
        this._getBackgroundColor = this._getBackgroundColor.bind(this);
        this._getCategory = this._getCategory.bind(this);
    }


    _getCategory(category) {
        switch (category) {
            case 'DREAMTEAM':
                return 'DREAM TEAM';
            case 'PREDICTION':
                return 'TARGET PREDICTION'
            case 'LIVE_PREDICTION':
                return 'LIVE PREDICTION';
            default:
                return ''
        }
    }

    _getMessage(transaction) {
        var message = ' '
        if (transaction.type == 'INVITE_FRIENDS') {
            message = strings('friend_invite_accepted', {friendName: transaction.friend.displayName});
        } else if (transaction.type == 'ENTRY_CREATION' || transaction.type == 'ENTRY_WON' || transaction.type == 'ENTRY_REFUND' || transaction.type == 'ENTRY_LOST') {

            message = transaction.entry.match.shortName + ' - ' + this._getCategory(transaction.entry.league.category);
            switch (transaction.type) {
                case 'ENTRY_LOST':
                    message = message + strings('lost')
                    break;
                case 'ENTRY_WON':
                    message = message + strings('won')
                    break;
                case 'ENTRY_REFUND':
                    message = message + strings('refunded')
                    break;
                case 'ENTRY_CREATION':
                    message = message + strings('entry_created')
                    break;
                default:
                    return colors.theme.bg_color10;
            }
        }
        else if(transaction.type=='REWARD_CLAIMED') {
            message = strings('reward_claimed_title', {reference : transaction.reward.reference})
        }
        else if(transaction.type=='DAILY_LOGIN_BONUS') {
            message = strings('daily_login_bonus')
        }
        else {
            message = CCUIUtils.getLocaleStr(transaction.message);
        }

        return message;
    }

    _getTitle(transaction) {
        var title = "";
        if (transaction.type == 'INVITE_FRIENDS') {
            title =strings('invitation_bonus')
        } else if (transaction.type == 'ENTRY_CREATION' || transaction.type == 'ENTRY_WON' || transaction.type == 'ENTRY_REFUND' || transaction.type == 'ENTRY_LOST') {
            switch (transaction.entry.league.category) {
                case 'DREAMTEAM':
                    transaction.entry.dreamTeam.map((player, index) => {
                        if (index == 0) {
                            title += player.name;
                        } else {
                            title += ', ' + player.name;
                        }
                    });
                    break;
                case 'PREDICTION':
                    title = strings('your_prediction', {prediction: transaction.entry.prediction});
                    break;
                case 'MOM':
                    title = strings('your_mom_entry', {momEntry: transaction.entry.momEntry.name});

                    break;
                case 'LIVE_PREDICTION':
                case 'QUICK_PREDICTION':
                    title= strings('your_live_prediction_entry', {prediction: transaction.entry.prediction });
                    break;
            }
        }
        else if(transaction.type=='REWARD_CLAIMED') {
            title = strings('reward_claimed_msg', {reference : transaction.reward.reference})
        }
        else if(transaction.type=='DAILY_LOGIN_BONUS') {
            title = strings('daily_login_bonus_claimed')
        }
        else {
            title = CCUIUtils.getLocaleStr(transaction.title);
        }

        return title;
    }

    _getBackgroundColor(transaction) {
        switch (transaction.type) {
            case 'ENTRY_LOST':
                return colors.theme.bg_color6
                break;
            case 'ENTRY_WON':
                return colors.theme.bg_color10;
                break;
            case 'ENTRY_REFUND':
                return colors.theme.bg_color13;
                break;
            case 'ENTRY_CREATION':
                return colors.theme.bg_color6;
                break;
            case 'INVITE_FRIENDS':
                return colors.theme.bg_color10;
                break;
            default:
                return colors.theme.bg_color10;
        }
    }


    render() {
        let transaction = this.props.transaction;
        let bgColor = this._getBackgroundColor(transaction);

        var title = this._getTitle(transaction);
        var message = this._getMessage(transaction);
        var time = CCUtils.formatTime(transaction.date);

        return (
            <div className="cc-transaction-container" style={{...this.props.style}}>
                <div className="flex-container transaction-bg" >
                    <div className="flex-container transaction-title">
                        <div className="cc-transaction-container3">
                            <div className="flex-transaction" >
                                <div  className="flex-container" >
                                    <h1 className="title" >{message}</h1>
                                    <h3  className="time">{time}</h3>
                                </div>
                            </div>
                            <div className="flex-container" style={{flex: 1}}>
                                <h3 className="title3">{title}</h3>
                                <CCCoinPile className={'flex-container flex-transaction'} textClass={'transaction-coin-font'} iconClass={'transaction-coin-icon'} theme={'dark'}
                                            coins={transaction.coins} style={{height: '5vw'}}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TransactionItem


// WEBPACK FOOTER //
// ./src/app/components/CCTransactionItem/CCTransactionItem.js